 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"main": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + "fdc488ad" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-05ee3505":1,"chunk-06326d46":1,"chunk-06de0401":1,"chunk-08d53cc4":1,"chunk-0e5113fc":1,"chunk-1157a79c":1,"chunk-12491bb8":1,"chunk-161f64a8":1,"chunk-1b4f627a":1,"chunk-1feafd62":1,"chunk-279952da":1,"chunk-2abf334b":1,"chunk-0d5fb9e1":1,"chunk-6fb1db1c":1,"chunk-1de33438":1,"chunk-a1ef1bfa":1,"chunk-3fb04862":1,"chunk-56b3bc9c":1,"chunk-58448f6e":1,"chunk-7595985d":1,"chunk-78a8216c":1,"chunk-7c753c84":1,"chunk-7ce767b9":1,"chunk-56e1a7ba":1,"chunk-0a1a3818":1,"chunk-55b30443":1,"chunk-1a744134":1,"chunk-348549bb":1,"chunk-207d7849":1,"chunk-23a85f84":1,"chunk-50774c82":1,"chunk-9c49842a":1,"chunk-e57476aa":1,"chunk-39e52a97":1,"chunk-2bb2582f":1,"chunk-3a74e0d8":1,"chunk-3108a1ed":1,"chunk-318c8012":1,"chunk-3338cd34":1,"chunk-346780eb":1,"chunk-3d07d077":1,"chunk-428d88d4":1,"chunk-49539fc6":1,"chunk-4a48c9ac":1,"chunk-4f07715c":1,"chunk-51db906f":1,"chunk-56508753":1,"chunk-5bfd4ae6":1,"chunk-5ec4dc84":1,"chunk-60b8e624":1,"chunk-61981bd9":1,"chunk-42843a45":1,"chunk-54e52908":1,"chunk-76b45ca8":1,"chunk-7ccf990e":1,"chunk-7cd9e484":1,"chunk-113b01f2":1,"chunk-3abfb531":1,"chunk-1ed2960c":1,"chunk-c236afc2":1,"chunk-d8df664e":1,"chunk-fef2d126":1,"chunk-63e19274":1,"chunk-68701522":1,"chunk-6dd361ae":1,"chunk-7ac1f114":1,"chunk-7f1b3e00":1,"chunk-83312eba":1,"chunk-8849681a":1,"chunk-8ab6b348":1,"chunk-8f9c7c34":1,"chunk-92aec8e6":1,"chunk-96c3d294":1,"chunk-9a9771fa":1,"chunk-a28c1878":1,"chunk-af947c9a":1,"chunk-b9901874":1,"chunk-c313b838":1,"chunk-c59b6470":1,"chunk-c7f139da":1,"chunk-c934fd62":1,"chunk-cd4e9260":1,"chunk-dae7e154":1,"chunk-eccb43f2":1,"chunk-f74ab26c":1,"chunk-f8921ebe":1,"chunk-c63d6770":1,"chunk-543ec4c1":1,"chunk-7b4fe34b":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-05ee3505":"a81bfca5","chunk-06326d46":"92d4ab9e","chunk-06de0401":"bd637e2d","chunk-08d53cc4":"c978fb4a","chunk-0c7b2c68":"31d6cfe0","chunk-0e5113fc":"3197986e","chunk-1157a79c":"33fed185","chunk-12491bb8":"14972a5b","chunk-161f64a8":"4dec8ecb","chunk-1b4f627a":"e202d755","chunk-1feafd62":"10cfd6b9","chunk-279952da":"e05219fe","chunk-2abf334b":"1e7a6eec","chunk-0d5fb9e1":"dcdd7b72","chunk-6fb1db1c":"81bf7003","chunk-2d0b2b47":"31d6cfe0","chunk-1de33438":"1a52cdaa","chunk-2d0b2ee5":"31d6cfe0","chunk-2d0c510d":"31d6cfe0","chunk-a1ef1bfa":"5942be12","chunk-3fb04862":"2a68ade9","chunk-56b3bc9c":"acfdac54","chunk-58448f6e":"e3a2ee89","chunk-7595985d":"dde3c55b","chunk-78a8216c":"2b17104f","chunk-7c753c84":"59c59b10","chunk-7ce767b9":"d49fb6af","chunk-56e1a7ba":"adb85d17","chunk-fc1dd094":"31d6cfe0","chunk-0a1a3818":"e6e9d25c","chunk-55b30443":"0439cd21","chunk-619d7aac":"31d6cfe0","chunk-1a744134":"33f35cf5","chunk-348549bb":"99ecbdbc","chunk-207d7849":"1f4833bb","chunk-23a85f84":"a411b598","chunk-50774c82":"8b742667","chunk-9c49842a":"4544ed88","chunk-e57476aa":"cf4f3657","chunk-39e52a97":"1fdd0901","chunk-2bb2582f":"ea684d97","chunk-2d0c8206":"31d6cfe0","chunk-2d0d4051":"31d6cfe0","chunk-3a74e0d8":"be37ec8f","chunk-2d0e9702":"31d6cfe0","chunk-2d0f028e":"31d6cfe0","chunk-2d20e788":"31d6cfe0","chunk-2d2160f1":"31d6cfe0","chunk-2d229afb":"31d6cfe0","chunk-3108a1ed":"ac39bffa","chunk-318c8012":"6fe789e9","chunk-3338cd34":"c978fb4a","chunk-346780eb":"d1ac2c69","chunk-3d07d077":"0886a3ec","chunk-428d88d4":"7b594e3d","chunk-4463fdfe":"31d6cfe0","chunk-49539fc6":"fac7ca08","chunk-4a48c9ac":"5dcf8740","chunk-4f07715c":"32b4a5cd","chunk-51db906f":"6a809503","chunk-56508753":"28c24f36","chunk-5bfd4ae6":"0886a3ec","chunk-5ec4dc84":"9b6af8fc","chunk-60b8e624":"07187c5e","chunk-61981bd9":"cb35d6e4","chunk-42843a45":"2fba676f","chunk-54e52908":"de989f6a","chunk-76b45ca8":"ff4e1bbe","chunk-7ccf990e":"6752105c","chunk-7cd9e484":"a5b956d0","chunk-113b01f2":"0e62e291","chunk-3abfb531":"5360cede","chunk-1ed2960c":"b8da32d5","chunk-c236afc2":"06377243","chunk-d8df664e":"a2eb72b3","chunk-fef2d126":"672bc62b","chunk-63e19274":"bcebd232","chunk-68701522":"a37d274b","chunk-6dd361ae":"7bd47d96","chunk-74c48a5b":"31d6cfe0","chunk-7ac1f114":"50881934","chunk-7f1b3e00":"fdff0fbc","chunk-83312eba":"db74c3f3","chunk-8849681a":"995c8cd8","chunk-8ab6b348":"2e8340e5","chunk-8f9c7c34":"96b24a5f","chunk-92aec8e6":"228a108f","chunk-96c3d294":"0d2683c4","chunk-9a9771fa":"048aad50","chunk-a28c1878":"a2aad21b","chunk-af947c9a":"8d3c9cfb","chunk-b9901874":"d13c34be","chunk-c313b838":"414a2024","chunk-c59b6470":"80b4c4ce","chunk-c7f139da":"9f606c55","chunk-c934fd62":"5edfee1f","chunk-2d0ae9a7":"31d6cfe0","chunk-cd4e9260":"33fed185","chunk-cf3b0bda":"31d6cfe0","chunk-dae7e154":"8f37a07e","chunk-eccb43f2":"0886a3ec","chunk-f74ab26c":"52dba225","chunk-f8921ebe":"34c5d3fe","chunk-c63d6770":"9c0e0639","chunk-543ec4c1":"dc9e3599","chunk-7b4fe34b":"05f78818"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//cdnstatic.gamekee.com/wiki/4.0/pc/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push(["a949","chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
